import type { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import type { TFunction } from 'i18next';

export interface DoneNoticeKeys {
  titleKey: string;
  descriptionKey: string;
}

/** The optional-step wording: re-entry stays additive. The anchor steps pass their own. */
export const OPTIONAL_DONE_NOTICE: DoneNoticeKeys = {
  titleKey: 'initialSetup.doneNotice.optional.title',
  descriptionKey: 'initialSetup.doneNotice.optional.description'
};

/** The done badge and callout of a setup step, as `WizardStepHeader` takes them. */
export function setupDoneNotice(
  t: TFunction,
  keys: DoneNoticeKeys = OPTIONAL_DONE_NOTICE
): { doneBadge: string; doneNotice: { title: string; description: ReactNode } } {
  return {
    doneBadge: t('initialSetup.doneBadge'),
    doneNotice: {
      title: t(keys.titleKey),
      // The anchor-step copy emphasizes "Weiter" per the design
      description: (
        <Trans
          i18nKey={keys.descriptionKey}
          components={{ bold: <span className="font-semibold text-foreground" /> }}
        />
      )
    }
  };
}
